<section class="feature-details">
  <div class="container">
    <a class="back-link" [href]="'#' + environment.FeatureConfig.id"> {{ title.backToLabel }} </a>

    <div class="details-content">
      <!-- LEFT COLUMN -->
      <div class="details-main">
        <span class="details-label"> {{ title.title }} </span>

        <h1>
          {{ card.title }}
        </h1>

        <div class="details-paragraphs">
          @for (paragraph of card.details; track paragraph) {
          <p>
            {{ paragraph }}
          </p>
          }
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="details-side">
        <div class="details-paragraphs">
          @if (card.showOptions) {
          <h2 class="options-title">
            {{ card.optionsLabel }}
          </h2>
          @for (option of card.options; track option) {
          <p>
            {{ option }}
          </p>
          }
          }
        </div>

        <h2 class="checkin-title">
          {{ card.checkinHeading }}
        </h2>

        <p class="checkin-details">
          {{ card.checkinDetails }}
        </p>

        @if(booking && booking.id) {
          <a [href]="'#' + booking.id" class="primary-btn"> {{ title.detailsbuttonLabel }} </a>
        }
      </div>
      <div class="gallery-container">
        <div class="feature-gallery">
          <div class="thumb-strip">
            @for (image of images; track image.srcUrl; let i = $index) {
              <button type="button" class="thumb" [class.active]="i === selectedIndex" (click)="select(i)" [attr.aria-label]="image.alt" [title]="image.alt">
                <img [src]="image.previewUrl" [alt]="image.alt" loading="lazy" />
              </button>
            }
          </div>

          <div class="hero-frame">
            <button type="button" class="hero-image" (click)="open(selectedIndex)" [attr.aria-label]="images[selectedIndex].alt">
              <img [src]="images[selectedIndex].previewUrl" [alt]="images[selectedIndex].alt" />
            </button>

            @if (images[selectedIndex].alt) {
              <div class="hero-caption">{{ images[selectedIndex].alt }}</div>
            }

            @if (images.length > 1) {
              <button type="button" class="nav-arrow prev" (click)="prev()" aria-label="Previous image">
                <i class="fa-solid fa-chevron-left"></i>
              </button>
              <button type="button" class="nav-arrow next" (click)="next()" aria-label="Next image">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            }

            <button type="button" class="view-all-btn" (click)="open(selectedIndex)">
              <i class="fa-solid fa-expand"></i> View All
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
